import React, { useContext } from 'react'
import { AddBox, NotInterested } from '@material-ui/icons/'
import listContext from '../../../Common/context/context'
import PropTypes from 'prop-types'


const ExcludePropertyFromList = props => {

    const { propertyId } = props
    const { propertyList, setPropertyList } = useContext(listContext)


    const handleExcludeProperty = () => {
        let newPropertyList = { ...propertyList }
        let compsList = [...newPropertyList.compsList]
        let index = compsList.findIndex(x => x.omniViewPropertyId === propertyId)
        compsList[index].excludeProperty = !compsList[index].excludeProperty;
        newPropertyList.compsList = [...compsList]
        setPropertyList({ ...newPropertyList })

    }
    const isExcluded = () => {
        let compsList = [...propertyList.compsList]
        let index = compsList.findIndex(x => x.omniViewPropertyId === propertyId)
        return compsList[index].excludeProperty
    }
    return (
        <>
            <button data-testid="test-button-exclude-property" className='btn btn-sm' onClick={() => { handleExcludeProperty() }}>
                {isExcluded() ? <AddBox fontSize="small" /> : <NotInterested fontSize="small" />}
            </button>
        </>
    )
}
ExcludePropertyFromList.propTypes = {
    propertyId: PropTypes.string
}

export default ExcludePropertyFromList
